import { render, staticRenderFns } from "./DeDate.vue?vue&type=template&id=afbfe012&scoped=true"
import script from "./DeDate.vue?vue&type=script&lang=js"
export * from "./DeDate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afbfe012",
  null
  
)

export default component.exports